import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: API, withCredentials: true });

const cached = (url) => {
  let p;
  return () => {
    if (!p) p = axios.get(`${API}${url}`).then((r) => r.data).catch((e) => { p = null; throw e; });
    return p;
  };
};

export const fetchLocations = cached("/locations");
export const fetchOtpConfig = cached("/otp/config");
export const fetchRoles = cached("/roles");
export const fetchPricing = cached("/settings/pricing");

export const submitLead = (kind, payload) => axios.post(`${API}/leads/${kind}`, payload).then((r) => r.data);

export const errorMessage = (err) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const d = detail[0];
    const field = d.loc?.includes("kyc") ? null : d.loc?.[d.loc.length - 1];
    return `${field && field !== "body" ? `${String(field).replace(/_/g, " ")}: ` : ""}${d.msg.replace("Value error, ", "")}`;
  }
  return "Something went wrong. Please try again.";
};
